export const DEVELOPMENT_AREAS_API = {
  COUNT: '/queries/development_areas/count',
  /** The tags in use on development areas: the Tags filter's options. */
  TAGS: '/queries/development_areas/tags',
} as const;

export const SOURCE_DOCUMENT_ASSIGNMENT_DROPDOWN_ITEMS = [
  { id: 'assigned', text: 'Assigned' },
  { id: 'unassigned', text: 'Unassigned' },
];

export const DEVELOPMENT_AREA_SEARCH_PLACEHOLDER =
  'Search development areas or tags.';
